export enum ProductTypeEnum {
    MOBILE = 'Mobile'
}